// Shim for using Clerk from CDN with TypeScript 3.4.5
declare global {
  interface Window {
    Clerk: any;
  }
}

// Wait for Clerk to be available on window and loaded
export function waitForClerk(): Promise<any> {
  return new Promise((resolve, reject) => {
    const checkAndLoad = async () => {
      if (window.Clerk) {
        try {
          await window.Clerk.load();
          resolve(window.Clerk);
        } catch (error) {
          reject(error);
        }
      } else {
        // If Clerk isn't available yet, wait and retry
        const checkInterval = setInterval(async () => {
          if (window.Clerk) {
            clearInterval(checkInterval);
            try {
              await window.Clerk.load();
              resolve(window.Clerk);
            } catch (error) {
              reject(error);
            }
          }
        }, 100);
        
        // Timeout after 10 seconds
        setTimeout(() => {
          clearInterval(checkInterval);
          reject(new Error('Clerk failed to load'));
        }, 10000);
      }
    };
    
    checkAndLoad();
  });
}

export default window.Clerk;